import { Button, Divider, Flex, Input } from '@hover/blueprint';
import React from 'react';

import { VariationSearchItem } from 'src/modules/designStudio/components/DesignMenu/ProductCatalogMenu/ProductSearch/SearchByName/VariationSearchItem';
import {
  TestIds,
  TestPageIds,
} from 'src/modules/designStudio/components/DesignMenu/ProductCatalogMenu/ProductSearch/TestIds';
import { ScrollMenu } from 'src/modules/designStudio/components/DesignMenu/ScrollMenu';
import type { Variation } from 'src/modules/designStudio/helpers/productSelection/types';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

export type SearchVariationByStringParams = {
  searchTerm: string;
  onCancel: () => void;
  onViewProductDetails: (v: Variation) => void;
  onSearchChanged: React.ChangeEventHandler<HTMLInputElement>;
  variations: Variation[];
};

export const SearchVariationByString = ({
  searchTerm,
  onSearchChanged,
  onCancel,
  variations,
  onViewProductDetails,
}: SearchVariationByStringParams) => {
  const t = useTranslate(TranslationNamespace.DESIGN_STUDIO);
  return (
    <ScrollMenu.Menu data-testid={TestPageIds.SEARCH}>
      <ScrollMenu.Header py={{ base: 400, tablet: 600 }}>
        <Flex direction="row" width="100%">
          <Input
            borderRadius="20px"
            onChange={onSearchChanged}
            sx={{
              _focus: {
                boxShadow: '0px 0px 0px 2px rgba(0, 0, 0, 0.92)',
              },
            }}
            value={searchTerm}
            width="100%"
          />
          <Button
            data-testid={TestIds.CANCEL_BUTTON}
            onClick={onCancel}
            paddingLeft="15px"
            paddingRight="10px"
            variant="ghost"
          >
            <Flex fontSize="19px" fontWeight="normal">
              {t('productCatalogMenu.cancel')}
            </Flex>
          </Button>
        </Flex>
      </ScrollMenu.Header>
      <ScrollMenu.Body>
        <Flex direction="column">
          {variations.map((variation, index) => (
            <Flex direction="column" key={variation.uuid}>
              <VariationSearchItem
                onSelect={() => {
                  onViewProductDetails(variation);
                }}
                variation={variation}
              />
              {index !== variations.length - 1 && <Divider />}
            </Flex>
          ))}
        </Flex>
      </ScrollMenu.Body>
    </ScrollMenu.Menu>
  );
};
